import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class UserFormattingService {
    /**
     * Returns a string with the first and last name concatenated. If either the first or last name is null, it will return a string with only the non-null name. If both names are null, it will return an empty string.
     */
    getDisplayName(firstName: string | null, lastName: string | null): string {
        return `${firstName || ''} ${lastName || ''}`.trim();
    }
}
